"use client"

import { getNonUmbracoUrl } from "@/utils"
import styled from "@emotion/styled"
import { Box, ButtonProps as MuiButtonProps } from "@mui/material"
import React from "react"
import { sendBlockEvent } from "utils/gtm"
import { iconsMap } from "../../public/icons/iconsMap"
import AccordionItem from "../common/bit/AccordionItem"
import ButtonWithArrow from "../common/bit/ButtonWithArrow"
import CommonTitle from "../common/bit/CommonTitle"
import { mediaQueries, sizes } from "../theme/theme"

interface ButtonProps extends MuiButtonProps {
  url?: string
  name?: string
}

interface AccordionItemProps {
  title?: string
  button?: ButtonProps
  itemsList: {
    question?: string
    answer?: string
    title?: string
    text?: string
  }[]
  id?: string
  componentEventName?: string
  blockTitle?: string
}

const StyledAccordionList = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .MuiButton-root {
    margin-top: ${sizes.baseSix};
  }

  ${mediaQueries.desktop} {
    max-width: 1126px;
  }
  ${mediaQueries.desktopXl} {
    max-width: 1026px;
  }
`
const StyledItemsList = styled("ul")`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  margin: 0;
  gap: 16px;
`
const StyledButtonText = styled.div`
  font-size: 16px;
  line-height: 19px;
  font-weight: 700;
`
const StyledButtonWithArrow = styled(ButtonWithArrow)`
  padding-top: ${sizes.baseDouble};
  padding-bottom: ${sizes.baseDouble};
`

const AccordionItemsList: React.FC<
  React.PropsWithChildren<AccordionItemProps>
> = ({ title, button, itemsList, id, componentEventName, blockTitle }) => {
  const ArrowIcon = iconsMap.left_red_arrow

  // Build FAQPage structured data if itemsList exists and is not empty
  let faqSchema = null
  if (itemsList && Array.isArray(itemsList) && itemsList.length > 0) {
    faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: itemsList.map((item: any) => ({
        "@type": "Question",
        name: item.question || item.title || "",
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer || item.text || "",
        },
      })),
    }
  }
  return (
    <>
      {faqSchema && (
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      )}
      <StyledAccordionList>
        {title && <CommonTitle>{title}</CommonTitle>}
        <StyledItemsList>
          {itemsList &&
            itemsList.map((item, index: number) => {
              const { title: itemTitle, text, question, answer } = item
              const displayTitle = question || itemTitle || ""
              const handleAccordionClick = () => {
                // Fire GTM event here
                sendBlockEvent({
                  blockId: id || "3", // Pass block id if available
                  title: blockTitle,
                  componentName: componentEventName || "שאלות ותשובות",
                  buttonName: displayTitle,
                  actionName: undefined,

                  // component_no: "5"
                })
              }
              return (
                <AccordionItem
                  key={`accordion-item-${displayTitle}-${index}`}
                  title={displayTitle}
                  text={answer ?? text ?? ""}
                  openIcon={
                    <ArrowIcon style={{ transform: "rotate(-90deg)" }} />
                  }
                  closeIcon={
                    <ArrowIcon style={{ transform: "rotate(-90deg)" }} />
                  }
                  onClick={handleAccordionClick}
                />
              )
            })}
        </StyledItemsList>
        {button && (
          <StyledButtonWithArrow
            href={getNonUmbracoUrl(button?.url)}
            onClick={() => {
              sendBlockEvent({
                blockId: id || "3", // Pass block id if available
                title: title,
                componentName: componentEventName || "שאלות ותשובות",
                buttonName: button?.name,
                actionName: undefined,

                // component_no: "5"
              })
            }}
          >
            <StyledButtonText>{button?.name}</StyledButtonText>
          </StyledButtonWithArrow>
        )}
      </StyledAccordionList>
    </>
  )
}
export default AccordionItemsList
